import Handbook from "./Handbook"

export default Handbook